/* TYB Judge.me runtime contrast guard.
   Judge.me can inject or restyle reviews after the theme CSS has loaded; this
   applies the contrast directly to text nodes without changing stars/buttons. */
(() => {
  'use strict';

  const ROOT_SELECTOR = '#judgeme_product_reviews, .jdgm-widget, .jdgm-review-widget, .jdgm-rev-widg';
  const EXCLUDE_SELECTOR = '.jdgm-star, [class*="star" i], [class*="rating" i], [class*="icon" i], [class*="btn" i], button, input, textarea, select, option, svg, path, img, picture, video';
  const TEXT = '#f3f1eb';
  const MUTED = '#aaa69e';
  const LINK = '#c3a27a';
  let scheduled = false;

  const hasOwnVisibleText = (element) =>
    Array.from(element.childNodes).some(
      (node) => node.nodeType === Node.TEXT_NODE && (node.textContent || '').trim().length > 0
    );

  const desiredColor = (element) => {
    const classes = String(element.className || '').toLowerCase();
    const text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    if (classes.includes('timestamp') || classes.includes('review-date') || classes.includes('review_date')) {
      return MUTED;
    }

    if (
      classes.includes('read-more') ||
      classes.includes('read_more') ||
      classes.includes('body-read-more') ||
      text === 'more' ||
      text === 'read more'
    ) {
      return LINK;
    }

    return TEXT;
  };

  const setImportantColor = (element, color) => {
    if (element.style.getPropertyValue('color') !== color || element.style.getPropertyPriority('color') !== 'important') {
      element.style.setProperty('color', color, 'important');
    }

    if (
      element.style.getPropertyValue('-webkit-text-fill-color') !== color ||
      element.style.getPropertyPriority('-webkit-text-fill-color') !== 'important'
    ) {
      element.style.setProperty('-webkit-text-fill-color', color, 'important');
    }

    if (element.style.getPropertyValue('opacity') === '0') {
      element.style.setProperty('opacity', '1', 'important');
    }
  };

  const paintElement = (element) => {
    if (!(element instanceof HTMLElement)) return;
    if (!element.closest(ROOT_SELECTOR)) return;
    if (element.matches(EXCLUDE_SELECTOR) || element.closest('button')) return;
    // TYB Oct 21 2026: leave the Verified badge to CSS (black on white); off-white on mint was unreadable.
    if (element.closest('.jm-verified-badge, .jdgm-rev__buyer-badge, [class*="verified-badge" i]')) {
      element.style.removeProperty('color');
      element.style.removeProperty('-webkit-text-fill-color');
      return;
    }
    if (!hasOwnVisibleText(element)) return;

    setImportantColor(element, desiredColor(element));
  };

  const applyContrast = () => {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      paintElement(root);
      root.querySelectorAll('*').forEach(paintElement);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyContrast();
    });
  };

  const start = () => {
    schedule();
    [100, 300, 700, 1400, 2500, 4500, 8000].forEach((delay) => window.setTimeout(schedule, delay));

    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
